// Standard library imports
import React, { useEffect, useState } from 'react';
// Internal module imports
import TabsComponent from '../../../../../components/Tabs/Tabs';
import AdminUser from './AdminUser';
import CreateUser from './CreateUser';

const UserIndex = ({ adminId, allAdmins }) => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [createEditUser, setCreateEditUser] = useState({ status: false, adminId: null, data: {} });

    useEffect(() => {
        if (selectedIndex === 0) setCreateEditUser({ status: false, adminId: null, data: {} });
    }, [selectedIndex]);

    const tabs = [
        {
            name: 'Users',
            component: <AdminUser adminId={adminId} setSelectedIndex={setSelectedIndex} setCreateEditUser={setCreateEditUser} />,
            tabId: 1,
        },
        ...(createEditUser.status
            ? [
                  {
                      name: !createEditUser.data?._id ? 'Create User' : 'Edit User',
                      component: (
                          <>
                              <CreateUser editUser={createEditUser.data} autoFillAdminId={createEditUser.adminId} allAdmins={allAdmins} setSelectedIndex={setSelectedIndex} />
                          </>
                      ),
                  },
              ]
            : []),
    ];

    return (
        <div>
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
            />
        </div>
    );
};

export default UserIndex;
